import {
  CreateSinglePaymentCheckoutSessionPayloadType,
  createSinglePaymentCheckoutSessionApi,
} from '@/api/v1/billing/createSinglePaymentCheckoutSessionApi';
import {
  CreateSubscriptionCheckoutSessionPayloadType,
  createSubscriptionCheckoutSessionApi,
} from '@/api/v1/billing/createSubscriptionCheckoutSessionApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { ConfirmSubscriptionPayloadType, confirmSubscriptionApi } from '@/api/v1/billing/confirmSubscriptionApi';
import { ConfirmSinglePaymentPayloadType, confirmSinglePaymentApi } from '@/api/v1/billing/confirmSinglePaymentApi';

export const createSubscriptionCheckoutSession = async (payload: CreateSubscriptionCheckoutSessionPayloadType) => {
  try {
    const response = await createSubscriptionCheckoutSessionApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const createSinglePaymentCheckoutSession = async (payload: CreateSinglePaymentCheckoutSessionPayloadType) => {
  try {
    const response = await createSinglePaymentCheckoutSessionApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const confirmSubscription = async (payload: ConfirmSubscriptionPayloadType) => {
  try {
    const response = await confirmSubscriptionApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const confirmSinglePayment = async (payload: ConfirmSinglePaymentPayloadType) => {
  try {
    const response = await confirmSinglePaymentApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
